import api_config from "../../../api/config/_user";
import api_param from "../../../api/comptabilite/_configs"

// Cache (en mémoire, le temps de la session de l'onglet) de la liste des caissier(e)s
const CAISSIERES_CACHE_TTL_MS = 5 * 60 * 1000
const caissieres_cache = { promise: null, loaded_at: 0 }

export default {
    getCouponAuthorizedUsers() {
        return new Promise((resolve, reject) => {
            api_config.getCouponAuthorizedUsers().then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    setResetPwdCode(data) {
        return new Promise((resolve, reject) => {
            api_config.setResetPwdCode(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    changePassword(data) {
        return new Promise((resolve, reject) => {
            api_config.changePassword(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    /**
     * Liste des caissier(e)s, gardée en mémoire quelques minutes : elle est demandée par plusieurs pages
     * (journal de caisse, produits, créances, charges, coupons, tableau de bord) et change rarement.
     * Chaque appel reçoit une copie, les pages modifiant la liste (ajout de « Tous(tes) les caissiers(es) »).
     */
    selectListeCaissieres(data) {
        const now = Date.now()
        if (!caissieres_cache.promise || now - caissieres_cache.loaded_at > CAISSIERES_CACHE_TTL_MS) {
            caissieres_cache.loaded_at = now
            caissieres_cache.promise = api_config.selectListeCaissieres(data).catch((error) => {
                caissieres_cache.promise = null      // pas de mise en cache d'une erreur
                throw error
            })
        }
        return caissieres_cache.promise.then((response) => JSON.parse(JSON.stringify(response)))
    },

    saveCustomExclusion(data) {
        return new Promise((resolve, reject) => {
            api_param.saveCustomExclusion(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    selectCustomExclusions() {
        return new Promise((resolve, reject) => {
            api_param.selectCustomExclusions().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}